<script setup lang="ts">
import type { TAttachedOrganization } from '~/components/widget/attached-organizations/types'
import { WidgetOrganizationAsideContacts } from '~/components/widget/organization-aside-contacts'
import { EntityOrganizationLogo } from '~/components/entity/organization-logo'

const { t } = useI18n()

const props = defineProps<{
  variant?: 'white' | 'default'
  heading?: string
  intro?: string
  organizations?: TAttachedOrganization[]
}>()
</script>

<template>
  <SidebarBlock
    v-if="props.organizations && props.organizations.length > 1"
    :variant="props.variant || 'white'"
    :heading-text="props.heading || t('common.companies')"
  >
    <div v-if="props.intro" class="mb-3 text-sm leading-4">{{ props.intro }}</div>
    <div v-for="(item, i) in props.organizations" :key="i">
      <div class="flex items-center gap-4">
        <EntityOrganizationLogo :src="item.logo" :alt="item.title" :to="item.url" />

        <div>
          <NuxtLinkLocale
            v-if="item.url"
            :to="item.url"
            :aria-label="`${t('common.more_about')} ${item.title}`"
            class="hover:underline"
          >
            <Heading tag="h3" class="h6">{{ item.title }}</Heading>
          </NuxtLinkLocale>
          <Heading v-else tag="h3" class="h6">{{ item.title }}</Heading>
        </div>
      </div>
    </div>
  </SidebarBlock>

  <WidgetOrganizationAsideContacts
    v-if="props.organizations && props.organizations.length === 1"
    :organization="props.organizations[0]"
    enable-link
  />
</template>
